import { Tabs, Tab } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

export type DonorTabValue = 'all' | 'active' | 'inactive' | 'pending' | 'action_required';

interface DonorTabsProps {
  initialValue: DonorTabValue;
  callback: (value: DonorTabValue) => void;
}

interface TabItem {
  label: string;
  value: DonorTabValue;
}

const DonorTabs = ({ initialValue, callback }: DonorTabsProps) => {
  const [value, setValue] = React.useState<DonorTabValue>(initialValue);
  const { t } = useTranslation(['common']);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleChange = (_event: React.ChangeEvent<any>, newValue: DonorTabValue) => {
    setValue(newValue);
    callback(newValue);
  };

  const tabItems: TabItem[] = [
    { label: t('common:button.all'), value: 'all' },
    { label: 'Aktiva', value: 'active' },
    { label: 'Väntar', value: 'pending' },
    { label: 'Inaktiva', value: 'inactive' },
    { label: 'Åtgärd krävs', value: 'action_required' },
  ];

  return (
    <Tabs
      value={value}
      textColor='primary'
      onChange={handleChange}
      sx={{
        '& button': {
          textTransform: 'none',
        },
      }}
    >
      {tabItems.map((item) => (
        <Tab key={item.value} label={item.label} value={item.value} />
      ))}
    </Tabs>
  );
};

export default DonorTabs;
